const config = {
  embedded_email: 'w-field-field-2328-7608-197022-email',
  embedded_url: 'https://app.mailjet.com/widget/iframe/PfM/By',
  popin_email: 'w-field-field-2330-7621-197022-email',
  popin_gistId: 'w-field-field-2330-7621-197022-46609',
  popin_url: 'https://app.mailjet.com/statics/widget/iframe/PfM/BA'
}

export default config
